import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import profileImge from '../img/profileImage.png'
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import VerifiedIcon from '@mui/icons-material/Verified';
import ErrorIcon from '@mui/icons-material/Error';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Badge, Typography, styled } from '@mui/material';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ApiService from '../_services/ApiService';
import { fetchUserDetail } from '../redux';
import StarIcon from '@mui/icons-material/Star';

function User(props) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.userData);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });

  useEffect(() => {
    dispatch(fetchUserDetail());
  }, []);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <div>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2, px: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            disableRipple
          >
            <Avatar src={userData ? userData?.avatar_url : profileImge} onError={(e) => { e.target.src = profileImge }}
              sx={{ border: '1px solid #F14950 ', '& img': { objectFit: 'contain' } }}
            >
            </Avatar>
          </IconButton>
        </Tooltip>

      </Box>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            width: '200px',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <div className="class-name"></div>
        <Link to="/profile" className='text-decoration-none text-black '>
          <MenuItem>
            <ListItemIcon>
              <ManageAccountsIcon fontSize="small" />
            </ListItemIcon>
            <div >Account</div>
          </MenuItem>
        </Link>
        <Link to="/reviews" className='text-decoration-none text-black '>
        <MenuItem>
        <ListItemIcon>
          <StarIcon fontSize="small" />
        </ListItemIcon>
        <div>Reviews</div>
        </MenuItem>
        </Link>

        <div className="class-name"></div>
        <Link to="/logout" className='text-decoration-none text-black '>
          <div className='p-2 mx-3 pt-3'> <strong>LOG OUT</strong></div>
        </Link>
      </Menu>

    </div>

  );
}
// }
export default User;